"use client";

import Link from "next/link";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import NavContact from "./NavContact";
import NavHeading from "./NavHeading";
import Image from "next/image";
const links = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/#about" },
  { label: "Portfolio", href: "/gallery" },
  { label: "Services", href: "/#services" },
  { label: "Contact", href: "/contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NavHeading />
      <motion.nav
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="w-full sticky top-0 z-50"
      >
        <motion.div
          animate={{
            paddingTop: scrolled ? 12 : 4,
            paddingBottom: scrolled ? 12 : 4,
            backgroundColor: scrolled
              ? "rgba(248, 244, 239, 0.8)"
              : "transparent",
            boxShadow: scrolled ? "0 2px 8px rgba(0,0,0,0.1)" : "none",
            opacity: scrolled ? 0.95 : 1,
            width: "100vw",
            left: 0,
            position: "fixed",
            top: 0,
            zIndex: 50,
          }}
          transition={{ type: "spring", stiffness: 150, damping: 30 }}
          className="h-auto flex items-center"
        >
          <div className="max-w-8xl mx-auto px-6 w-full flex items-center justify-start space-x-4">
            {scrolled && (
              <>
                <Image
                  src="/QQQ.webp"
                  alt="Design Nook Logo"
                  width={100}
                  height={100}
                  priority
                  className="hidden md:block"
                />

                {/* Vertical divider */}
                <div className="h-20 w-[2px] bg-[#A65D5D] rounded hidden md:block" />
              </>
            )}

            <motion.h1
              initial={{ opacity: 0 }}
              animate={{ opacity: scrolled ? 1 : 0 }}
              transition={{ duration: 0.4 }}
              className="text-4xl  lg:text-6xl font-serif text-[#A65D5D] font-semibold tracking-tight"
            >
              Design Nook
            </motion.h1>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle Menu"
            className="fixed right-6 top-4 z-50"
          >
            {isOpen ? (
              <X className="w-10 h-10 md:w-15 md:h-15 text-[#A65D5D]" />
            ) : (
              <Menu className="md:w-12 md:h-12 w-10 h-10 p-1 text-[#A65D5D] font-bold" />
            )}
          </button>

          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ y: "-100%" }}
                animate={{ y: 0 }}
                exit={{ y: "-100%" }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="fixed inset-0 z-40"
              >
                {/* Background */}
                <div className="absolute inset-0 z-0">
                  <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url('/hero2.webp')` }}
                  />
                  <div className="absolute inset-0 bg-black/70 bg-opacity-90" />
                </div>

                {/* Responsive Content Wrapper */}
                <div className="relative z-10 flex items-center justify-center w-full h-full px-4 sm:px-8">
                  <div className="flex flex-col md:flex-row items-center justify-center rounded-lg p-3 gap-6 w-full max-w-5xl">
                    {/* Nav Links */}
                    <nav className="flex flex-col items-start text-start px-10  py-2 md:py-12 text-3xl sm:text-5xl md:text-5xl sm:space-y-5 space-y-4 max-w-xs w-full">
                      {links.map(({ label, href }) => (
                        <a
                          key={href}
                          href={href}
                          onClick={() => setIsOpen(false)}
                          className="relative w-full transition-colors duration-300 text-start  before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-0 before:bg-[#A65D5D] before:transition-all before:duration-300 group-hover:before:w-full"
                        >
                          <span className="group relative  text-center md:text-start text-white hover:text-[#A65D5D] inline-block w-full">
                            {label}
                          </span>
                        </a>
                      ))}
                    </nav>

                    {/* Divider for sm screens (horizontal), md+ (vertical) */}
                    <div className="w-full h-[2px] bg-[#A65D5D] md:hidden" />
                    <div className="hidden md:block w-[2px] h-auto bg-[#A65D5D]" />

                    {/* Contact Info */}
                    <div className="flex flex-col max-w-sm w-full rounded-lg p-4 md:p-10 text-base md:text-lg sm:items-center text-start">
                      <NavContact />
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </motion.nav>
    </>
  );
};

export default Navbar;

// //original code
// "use client";
// import Link from 'next/link';
// import { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Menu, X } from "lucide-react";

// const links = [
//   { label: "Home", href: "/" },
//   { label: "About", href: "/#about" },
//   { label: "Portfolio", href: "/gallery" },
//   { label: "Contact Us", href: "/contact" },
// ];

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <motion.nav
//       initial={{ y: -60, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.6, ease: "easeOut" }}
//       className="w-full sticky top-0 z-50"
//     >
//       <motion.div
//         animate={{ opacity: scrolled ? 0.99 : 1 }}
//         transition={{ type: "spring", stiffness: 150, damping: 30 }}
//         className="bg-[#F8F4EF]/60 shadow-sm"
//       >
//         <motion.div
//           animate={{
//             paddingTop: scrolled ? 12 : 14,
//             paddingBottom: scrolled ? 12 : 14,
//           }}
//           transition={{ type: "spring", stiffness: 150, damping: 30 }}
//           className="max-w-7xl mx-auto px-6 relative"
//         >
//           {/* Mobile Header */}
//           <div className="flex items-center justify-between lg:hidden md:hidden">
//             <motion.h1
//               animate={{ scale: scrolled ? 0.99 : 1 }}
//               transition={{ type: "spring", stiffness: 100, damping: 10 }}
//               className="text-4xl font-serif tracking-tight text-[#A65D5D]"
//             >
//               Design Nook
//             </motion.h1>
//             <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu">
//               {isOpen ? (
//                 <X className="w-7 h-7 text-[#3E2F2F]" />
//               ) : (
//                 <Menu className="w-7 h-7 text-[#3E2F2F]" />
//               )}
//             </button>
//           </div>

//           {/* Mobile Menu Overlay */}
//           <AnimatePresence>
//             {isOpen && (
//               <motion.div
//                 initial={{ y: "-100%" }}
//                 animate={{ y: 0 }}
//                 exit={{ y: "-100%" }}
//                 transition={{ duration: 0.4, ease: "easeInOut" }}
//                 className="fixed inset-0 bg-primaryColor-darker z-40 flex flex-col items-center justify-center space-y-5 text-4xl font-sans text-[#6B4F4F]"
//               >
//                 <button
//                   className="absolute top-6 right-6"
//                   onClick={() => setIsOpen(false)}
//                   aria-label="Close Menu"
//                 >
//                   <X className="w-8 h-8 text-[#3E2F2F]" />
//                 </button>

//                 {links.map(({ label, href }) => (
//                   <a
//                     key={href}
//                     href={href}
//                     onClick={() => setIsOpen(false)}
//                     className="relative group transition-colors duration-300 hover:text-[#A65D5D] before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-0 before:bg-[#A65D5D] before:transition-all before:duration-300 group-hover:before:w-full"
//                   >
//                     {label}
//                   </a>
//                 ))}
//               </motion.div>
//             )}
//           </AnimatePresence>

//           {/* Desktop Nav */}
//           <div className="hidden md:flex flex-col items-center text-center space-y-2">
//             <motion.h1
//               animate={{ scale: scrolled ? 0.95 : 1 }}
//               transition={{ type: "spring", stiffness: 150, damping: 30 }}
//               className="text-7xl font-serif tracking-tight text-[#A65D5D]"
//             >
//               Design Nook
//             </motion.h1>

//             <motion.ul
//               animate={{ scale: scrolled ? 0.85 : 1 }}
//               transition={{ type: "spring", stiffness: 150, damping: 30 }}
//               className="flex gap-8 text-2xl font-sans text-[#6B4F4F]"
//             >
//               {links.map(({ label, href }) => (
//                 <li key={href} className="relative group">
//                   <Link
//                     href={href}

//                     className="transition-colors duration-300 hover:text-[#A65D5D] before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-0 before:bg-[#A65D5D] before:transition-all before:duration-300 group-hover:before:w-full"
//                   >
//                     {label}
//                   </Link>
//                 </li>
//               ))}
//             </motion.ul>
//           </div>
//         </motion.div>
//       </motion.div>
//     </motion.nav>
//   );
// };

// export default Navbar;
